import { Component, ViewChild } from '@angular/core';

import { Platform, MenuController, Nav ,ToastController } from 'ionic-angular';
import { LoginComponent } from '../pages/login/login';
import { DashboardPage } from '../pages/dashboard/dashboard';
import { Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { CommonService } from './../services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { Device } from '@ionic-native/device';
@Component({
	templateUrl: 'app.html'
})
export class MyApp {
	@ViewChild(Nav) nav: Nav;

  // make HelloIonicPage the root (or first) page
  rootPage:any = LoginComponent;
  pages: Array<{title: string, component: any, icon : string}>;
  userFirstName:"";

  constructor(
  	public platform: Platform,
  	public menu: MenuController,
  	public statusBar: StatusBar,
  	public splashScreen: SplashScreen,
  	public events: Events,
  	public toastCtrl: ToastController,
    private commonService: CommonService, 
    private translate: TranslateService,
    private device: Device,
    ) {
    this.translate.setDefaultLang(commonService.selectedItem);
  	platform.ready().then(() => {

      

      if(this.device.uuid && this.device.uuid!="null"){
        localStorage.setItem('deviceToken',this.device.uuid);
      }
      //back button handle
      //Registration of push in Android and Windows Phone
      var lastTimeBackPress=0;
      var timePeriodToExit=2000;

      platform.registerBackButtonAction(() => {


         // get current active page
         let view = this.nav.getActive();
         if(view.component.name=="LoginComponent"){
              //Double check to exit app                  
              if(new Date().getTime() - lastTimeBackPress < timePeriodToExit){
                this.platform.exitApp(); 
                 //Exit from app
               }else{
                 let toast = this.toastCtrl.create({
                   message: 'Press back again to exit App?',
                   duration: 3000,
                   position: 'bottom'
                 });
                 toast.present();     
                 lastTimeBackPress=new Date().getTime();
               }
             }else{
               if (this.nav.canGoBack())
                 this.nav.pop().then(() => {}, () => {}); 
                // If called very fast in a row, pop will reject because no pages

              }
            }, 500);


    });

    this.initializeApp();    

    events.subscribe('user:logged-in', (user, time) => {
    	// user and time are the same arguments passed in `events.publish(user, time)`
      this.setPages(user);
      this.userFirstName=user.fullName.split(" ")[0];

    });


  }

  ionViewDidLoad() {

  }

  checkIfUserLoggedin(){

    if(localStorage.getItem('current-user') && localStorage.getItem('current-user')!=null){
      //return true;
      var userdata=JSON.parse(localStorage.getItem('current-user'));
      var userrole=userdata.isSuperAdmin;
      userrole=(userrole=="1")?'super-admin':'admin';
      this.setPages({role:userrole,subscribedPlan:userdata.company.subscribedPlan});
      this.userFirstName=userdata.fullName.split(" ")[0];
      this.rootPage=DashboardPage;
      //this.nav.setRoot("DashboardPage");

    }else{

      //window.location.href='http://localhost:8100';

      //this.doLogout();
    }
     
  }  

  initializeApp() {
  	this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.commonService.listenConnection();
      var appRateOption=localStorage.getItem('app-rate-option');
      if(appRateOption=="later"){
        localStorage.setItem('app-rate-option','');
      }

    });

    this.checkIfUserLoggedin();
  }

  openPage(page) {

     //do logout
     if(page.title=="Logout"){

       this.doLogout();

     }else{
       // close the menu when clicking a link from the menu
       this.menu.close();
      // navigate to the new page if it is not the current page
      this.nav.setRoot(page.component);

    }


  }

  setPages(user){

    if(user.role=="admin"){

      this.pages = [
      { title: 'Dashboard', component: 'DashboardPage', icon:'home' },
      { title: 'Get_Feedback', component: 'RatingPage' , icon:'star-half' },
      { title: 'Customer_List', component: 'CustomerPage' , icon:'people' },
      { title: 'Support', component: 'SupportPage' , icon:'mail' },
      {title : 'Settings', component : 'SettingsPage' , icon:'cog'  },
      {title : 'Logout', component : 'SettingsPage' , icon:'log-out'  },

      ];

    }else{

      // set our app's pages
      this.pages = [
      { title: 'Dashboard', component: 'DashboardPage', icon:'home' },
      { title: 'Get_Feedback', component: 'RatingPage' , icon:'star-half' },
      { title: 'Rating_Factor', component: 'RatingFactorPage' , icon:'create' },     
      { title: 'Customer_List', component: 'CustomerPage' , icon:'people' },
      { title: 'My QR code', component: 'QrcodePage' , icon:'qr-scanner' },
      { title: 'Support', component: 'SupportPage' , icon:'mail' },
      {title : 'Settings', component : 'SettingsPage' , icon:'cog'  },
      {title : 'Upgrade_Plan', component : 'PricingPage' , icon:'pricetag'  },
      {title : 'Logout', component : 'SettingsPage' , icon:'log-out'  },

      ];


      if(user.subscribedPlan){
        let ratingCollectorMenu={ title: 'Rating_Collector', component: 'RatingCollectorsPage' , icon:'person-add' };
        this.pages.splice( 3, 0, ratingCollectorMenu);
      }

    }
  }


  doLogout(){
   // close the menu when clicking a link from the menu
   this.menu.close();
   this.rootPage = LoginComponent;
      // navigate to the new page if it is not the current page
      localStorage.removeItem('current-user');
      if(this.nav){
           this.nav.setRoot(this.rootPage,{}, {animate: true, direction: "forward"})/*.then(() => {
        const startIndex = this.nav.getActive().index - 1;
        this.nav.remove(startIndex, 1);
      });*/

      this.nav.popToRoot();
    }else{    

      // this.nav.popToRoot();
    }


  }
  // private listenConnection(): void {
  //   this.network.onDisconnect()
  //     .subscribe(() => {
  //       this.showAlert();
  //     });

  //     if(this.network.type=="none"){
  //       this.showAlert();
  //     }

  // }

  

}





// WEBPACK FOOTER //
// ./src/app/app.component.ts